import { Kind } from '../components/prescriptionPad/rightPanel/workspace/PrescribeAutoSuggestV2';
import { MEDICINES_KIND } from '../components/prescriptionPad/trackSource';
import { isOnboardedForLab, isOnboardedForPharma } from '../pages/utils';
import { isIDristi } from '../store/idbHandler';
import { GET_MATCHING_DRUGS_LAB_TESTS } from './constants';
import { HXNG_MAPPED, HXNG_STATUS } from './fetchDrugsAndLabTestsStatus';
import fetchWithRefresh from './fetchWithRefresh';

export interface MatchingDrugsLabTestsResponse {
    drugs: Drug[];
    lab_tests: LabTest[];
}

export interface LabTest {
    id: string;
    name: string;
    book?: boolean;
    type?: string;
    content?: string[];
    vendor_names?: string[];
    vendor_ids?: string[];
    testing_type?: string;
    hxng_only?: boolean;
}

export const AFTER_MEAL = 'After Meal';
export const BEFORE_MEAL = 'Before Meal';

export const DRUG_DOSAGE_DURATION_TIMING_ENUM: { [key: string]: string } = {
    BF: BEFORE_MEAL,
    SF: AFTER_MEAL,
};

export interface Drug {
    id: string;
    name: string;
    manufacturer_name?: string;
    product_type?: string;
    product_sku?: string;
    generic_id?: string;
    generic_name?: string;
    dosage?: {
        df_id?: string;
        unit?: string;
        unit_val?: string;
        unit_id?: string;
        unit_name?: string;
        dosage?: string;
        dosage_form?: string;
        days?: string;
        food?: string;
    };
    soa?: boolean;
    hxng_mapped?: HXNG_MAPPED;
    hxng_status?: HXNG_STATUS;
    inventory_status?: {
        in_stock: boolean;
        price: number;
        quantity: number;
        evital_id: string;
    };
}

export enum S_TYPE {
    DRUG = 'drug',
    LAB = 'lab',
}

export default (
    text?: string,
    cat?: string,
    generic_id?: string,
    hide_custom?: boolean,
    cid?: string,
    fetchHXNGStatuses?: boolean,
    s_type?: S_TYPE | '',
    is_injection?: boolean,
    kind?: Kind,
    partner_clinic_id?: string,
): Promise<MatchingDrugsLabTestsResponse> => {
    let url = GET_MATCHING_DRUGS_LAB_TESTS(
        text || '',
        isOnboardedForPharma() || fetchHXNGStatuses,
        isOnboardedForLab() || fetchHXNGStatuses,
        cat || '',
        generic_id,
        !hide_custom,
        cid,
        s_type,
        is_injection,
    );
    if (isIDristi() && kind === MEDICINES_KIND) {
        url = `https://idrishti.in:6060/drishti/bootstrap/EkaEMRIntegration/Version_1.0/getMedicineInventory.jsp?location=${partner_clinic_id}&itemName=${text}`;
    }
    return fetchWithRefresh(url).then((res) => res.json());
};
